export function currencyFormat(num: number | undefined) {
    if (num === undefined || isNaN(num)) {
        return "$0.00";
    }
    return "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}